





















































































































import Vue from 'vue';

import settingsPannel from '../settings.vue';

import { MDCRipple } from '@material/ripple';
import { MDCList } from '@material/list';
import { MDCDialog } from '@material/dialog';
import { MDCSnackbar } from '@material/snackbar';

import Axios from 'axios';
import filesize from 'filesize';

import fileExplorer from '../../docs.vue';

export class Area {
  public id: string;
  public path: string;
  public active: boolean;
  constructor(obj: any) {
    this.id = obj.ID;
    this.path = obj.Path;
    this.active = false;
  }
}

interface Data {
  restrictedAreas: Area[];
  parent: boolean;

  areaToDeleteIfConfirm: Area;
  activePath: string;
  addErrSnac: any;

  listMDC: any;
  confirmDel: any;
}

export default Vue.extend({
  data(): Data {
    return {
      restrictedAreas: [],
      parent: true,

      areaToDeleteIfConfirm: new Area({}),
      activePath: '/',
      addErrSnac: null,

      listMDC: null,
      confirmDel: null,
    };
  },
  mounted() {
    const vue = this;
    Axios.get('/API/admin/restrictedAreas').then((resp: any) => {
      const areasAsObj: any[] = resp.data;
      for (const areaAsObj of areasAsObj) {
        const area = new Area(areaAsObj);
        vue.restrictedAreas.push(area);
      }

      vue.restrictedAreas.sort(vue.orderAreas);

      vue.makeupElements();
    });

    const addErrSnacElem: any = document.querySelector('#restrictedPathManagement .mdc-snackbar');
    this.addErrSnac = new MDCSnackbar(addErrSnacElem);

    const dialogElem: any = document.querySelector('#restrictedPathManagement .mdc-dialog');
    this.confirmDel = new MDCDialog(dialogElem);
  },
  updated() {
    this.makeupElements();
  },
  methods: {
    orderAreas(a: Area, b: Area): number {
      if (a.path < b.path) {
        return -1;
      }
      if (a.path > b.path) {
        return 1;
      }
      return 0;
    },
    addRestriction() {
      for (const area of this.restrictedAreas) {
        if (this.activePath === '' || this.activePath === '/' ||
          area.path.startsWith(this.activePath) ||
          this.activePath.startsWith(area.path)) {
          this.addErrSnac.open();
          return;
        }
      }

      const vue = this;
      Axios.post('/API/admin/restrictedArea', { Path: this.activePath }).then(((resp: any) => {
        const area: Area = new Area(resp.data);
        vue.restrictedAreas.push(area);
        vue.restrictedAreas.sort(vue.orderAreas);
      }));
    },
    clickDeleteRestriction(area: Area) {
      this.areaToDeleteIfConfirm = area;
      this.confirmDel.open();
    },
    deleteRestriction() {
      const vue = this;
      Axios.delete('/API/admin/restrictedArea/' + this.areaToDeleteIfConfirm.id).then((() => {
        let index = 0;
        for (const area of vue.restrictedAreas) {
          if (area.id === this.areaToDeleteIfConfirm.id) {
            vue.restrictedAreas.splice(index, 1);
            break;
          }
          index++;
        }
      }));
    },
    activePathChanged(param: string) {
      this.activePath = param;
    },
    makeupElements() {
      if (this.listMDC === null) {
        const elem = document.querySelector('#restrictedPathManagement .mdc-list');
        if (elem !== null) {
          this.listMDC = new MDCList(elem);
        }
      }
      const listItemRipples = this.listMDC.listElements.map((listItemEl: any) => {
        const listRiple = new MDCRipple(listItemEl);
        const delButton: any = listItemEl.querySelector('.mdc-button');
        const delButtonRipple = new MDCRipple(delButton);
      });

      const addButton: any = document.querySelector('#restrictedPathManagement .mdc-button');
      const buttonRipple = new MDCRipple(addButton);
    },
  },
  destroyed() {
    this.addErrSnac.destroy();
    this.listMDC.destroy();
    this.confirmDel.destroy();
  },
  components: {
    fileExplorer,
    settingsPannel,
  },
});
